import { TfiAnnouncement } from 'react-icons/tfi';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const announcements = {
  id: 'Announcements',
  title: '',
  type: 'group',
  children: [
    {
      id: 'announcements-management',
      title: 'Announcements',
      type: 'item',
      url: '/Announcements',
      icon: TfiAnnouncement,
      allowedRoles: ['admin', 'superAdmin', 'marketingSpecialist'],
      breadcrumbs: false
    }
  ]
};

export default announcements;
// ALL fund manager are requested to complete there onboarding as soon as posible
// Complete Onboarding
